import Texts from "../defaults/Text";
import ServiceCode from "../enums/ServiceCode";

const getServiceName = (serviceType: string) => {
    switch (serviceType) {

        case ServiceCode.WaterBranchAssignment:
            return Texts.WaterBranchAssignment
        case ServiceCode.WasteWaterBranchAssignment:
            return Texts.WasteWaterBranchAssignment

        case ServiceCode.ReplyToInquiry:
            return Texts.ReplyToInquiry

        case ServiceCode.ChangeAccountType:
            return Texts.ChangeAccountType

        case ServiceCode.ChangeSpecifications:
            return Texts.ChangeSpecifications

        case ServiceCode.ChangeUnit:
            return Texts.ChangeUnit

        case ServiceCode.ChangeCapacityContractualBranching:
            return Texts.ChangeCapacityContractualBranching

        case ServiceCode.ChangeBranchDiameter:
            return Texts.ChangeBranchDiameter

        case ServiceCode.MeterSeparation:
            return Texts.MeterSeparation

        case ServiceCode.MoveMeasuringDevices:
            return Texts.MoveMeasuringDevices

        case ServiceCode.MeterTest:
            return Texts.MeterTest

        case ServiceCode.MeterChange:
            return Texts.MeterChange
        case ServiceCode.InstallAdditionalSiphon:
            return Texts.InstallAdditionalSiphon
        case ServiceCode.TemporaryDisconnectAndConnectBranch:
            return Texts.TemporaryDisconnectAndConnectBranch
        case ServiceCode.CollectOrMergeBranch:
            return Texts.CollectOrMergeBranch
        case ServiceCode.MidTermBill:
            return Texts.MeterChange
        case ServiceCode.BillingReview:
            return Texts.BillingReview
        case ServiceCode.DeclareMeterConsumption:
            return Texts.DeclareMeterConsumption
        case ServiceCode.SeeHistory:
            return Texts.SeeHistory
        case ServiceCode.BillingPayment:
            return Texts.BillingPayment
        case ServiceCode.Suggestions:
            return Texts.Suggestions
        case ServiceCode.SaleTankerWater:
            return Texts.SaleTankerWater

        default:
            return ""
    }
}
export default getServiceName;